(function(global) {
	'use strict';
	
	/* ネスレ コラーゲンNOTE common.js */
	
	window.ISCO = window.ISCO || {};
	const ISCO = window.ISCO;
	
	ISCO.onLoaded = function(fns) {
		const setFns = [
			webFontLoader,
			improvementSource,
			windowManagement,
			refNote,
			setLazy,
			setInview,
			pagetopFix,
			anchorScroll,
			drawerMenu,
			kvOpening,
			createBarGraph
		];
		if (fns) {
			for (let i = 0, len = fns.length; i < len; i++) {
				setFns.push(fns[i]);
			}
		}
		addFnc(setFns);
		ISCO.loop();
	}
	ISCO.onResize = function() {
		resized(function() {
			if (as.duration !== undefined) as.onResize();
			if (wm.yOffset !== undefined) wm.refresh();
		});
	}
	ISCO.loop = function() {
		requestAnimationFrame(ISCO.loop);
		if (wm.yOffset !== undefined) wm.yOffset = window.pageYOffset;
		if (ptf.footer !== undefined) ptf.onScroll();
	}
	
	/**
	 * Web Font Loader
	 -------------------------------------------------- */
	function webFontLoader() {
		wf.constructor();
	}
	const wf = {
		constructor: function() {
			window.WebFontConfig = {
				custom: {
					families: [ 'Noto+Sans+JP' ],
					urls: [ 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap' ]
				},
				loading: function() {
					//console.log('loading');
				},
				active: function() {
					//console.log('active');
					if (as.duration !== undefined) as.onResize();
					sessionStorage.fonts = true;
				}
			};
			this.setup(document);
		},
		setup: function(d) {
			const wf = d.createElement('script'), s = d.scripts[0];
			wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
			wf.async = true;
			s.parentNode.insertBefore(wf, s);
		}
	};
	
	/**
	 * .js-op
	 -------------------------------------------------- */
	function kvOpening() {
		if (document.querySelector('.js-op') !== null) kvo.constructor();
	}
	const kvo = {
		constructor: function() {
			const kv = document.getElementsByClassName('js-op');
			for (let i = kv.length; i--;) {
				kv[i].classList.add('is-open');
				kv[i].classList.add('is-anim');
				kv[i].addEventListener('transitionend', this.openEnd);
			}
		},
		openEnd: function(e) {
			if (e.target.tagName.toLowerCase() === 'img' && e.propertyName === 'transform' ||
				e.target.className.indexOf('t3') !== -1 && e.propertyName === 'transform') {
				this.classList.remove('js-op');
				this.classList.remove('is-anim');
				this.classList.remove('is-open');
				this.removeEventListener('transitionend', kvo.openEnd);
			}
		}
	}


	
	/**
	 * window の情報を管理する
	 * モーダルが開いた時とかはここで画面をロックする
	 * windowManagement
	 -------------------------------------------------- */
	function windowManagement() {
		wm.constructor();
	}
	const wm = {
		constructor: function() {
			this.body = document.body;
			this.refresh();
		},
		refresh: function() {
			this.winH = window.innerHeight;
			this.yOffset = window.pageYOffset;
		},
		posLock: function() {
			wm.isLock = 1;
			wm.lockOffset = wm.yOffset;
			wm.body.classList.add('is-fixed');
			wm.body.style.marginTop = -wm.lockOffset + 'px';
		},
		posUnlock: function() {
			wm.body.classList.remove('is-fixed');
			wm.body.removeAttribute('style');
			window.scrollTo(0, wm.lockOffset);
			setTimeout(function() {
				wm.isLock = 0;
			}, 60);
		}
	};
	
	/**
	 * バーグラフを生成する
	 * <div class="c-bargraph" data-bargraph="{graph-id}"></div>
	 * graph.json に {graph-id} のデータを用意する
	 * -------------------------------------------------- */
	function createBarGraph() {
		// console.log(document.querySelector('.c-bargraph'));
		if (document.querySelector('.c-bargraph') !== null) {
			doAjax('./js/graph.json', json => {
					const elms = document.getElementsByClassName('c-bargraph');
					let data = {};
					for (let i = 0, len = elms.length; i < len; i++) {
						data = json[elms[i].dataset['bargraph']];
						cbg.constructor(elms[i], data);
					}
			}, 'json');
		}
	}
	const cbg = {
		constructor(elm, data) {
			let html = '<div class="graph_container">';
			html += `<p class="note">${data.caption}</p>`;
			html += this.returnScale(data);
			html += this.returnBars(data);
			html += this.returnIllust(data);
			html += '</div>';
			elm.insertAdjacentHTML('beforeend', html);
			
			// コンテンツ追加後にリフレッシュ
			setTimeout(() => { ISCO.onResize(); }, 20);
		},
		returnBars(data) {
			const lineup = data.lineup;
			let html = '<ul class="graph">';
			for (let i = 0, len = lineup.length; i < len; i++) {
				html += '<li class="item">';
				html += `<span class="label">${lineup[i].label}</span>`;
				html += `<span class="bar"><span class="fill" style="width:${lineup[i].length / 10}%"></span></span>`;
				html += '</li>';
			}
			html += '</ul>';
			return html;
		},
		returnScale(data) {
			const scale = data.scale;
			let html = '<ul class="scale">';
			let n = [], w;
			for (let i = 0, len = scale.length; i < len; i++) {
				n = String(scale[i]).split('');
				html += `<li class="num">`;
				for (let j = 0, l = n.length; j < l; j++) {
					w = n[j] === '1' ? 7: n[j] === '4' ? 11 : n[j] === '7' ? 9 : 10;
					html += `<svg width="${w}" height="20" viewBox="0 0 ${w} 20">`;
					html += `<use href="../assets/img/graph_num.svg#n${n[j]}"/></svg>`;
				}
				html += `</li>`;
			}
			html += '</ul>';
			return html;
		},
		returnIllust(data) {
			const illust = data.illust;
			let html = '<div class="illust">';
			for (let i = 0, len = illust.length; i < len; i++) {
				html += `<span class="il -i${i+1}">`;
				html += `<img src="../assets/img/${illust[i].src}" alt="${illust[i].alt}" width="${illust[i].width}" height="${illust[i].height}">`;
				html += `</span>`;
			}
			html += '</div>';
			return html;
		}
	}
	
	/**
	 * ドロワーメニュー
	 * dm.closeMenu();
	 -------------------------------------------------- */
	function drawerMenu() {
		if (document.querySelector('.l-menu') !== null) dm.constructor();
	}
	const dm = {
		constructor: function() {
			//console.log('-----> drawerMenu');
			this.menu = document.getElementsByClassName('l-menu')[0];
			this.btn = document.getElementsByClassName('js-menuToggle');
			for (let i = 0, len = this.btn.length; i < len; i++) {
				this.btn[i].addEventListener('click', this.toggleMenu);
				this.btn[i].addEventListener('transitionend', this.btnEnd);
			}
			// console.log(this.btn);
		},
		toggleMenu: function() {
			!dm.isOpened ? dm.openMenu() : dm.closeMenu();
			dm.menu.addEventListener('transitionend', dm.menuEnd);
		},
		openMenu: function() {
			//console.log('openMenu');
			dm.isOpened = true;
			dm.menu.classList.add('is-active', 'is-anim');
			for (let i = 0, len = dm.btn.length; i < len; i++) {
				dm.btn[i].classList.add('is-active', 'is-anim');
			}
		},
		closeMenu: function() {
			//console.log('closeMenu');
			dm.isOpened = false;
			dm.menu.classList.replace('is-active', 'is-anim');
			for (let i = 0, len = dm.btn.length; i < len; i++) {
				dm.btn[i].classList.replace('is-active', 'is-anim');
			}
		},
		menuEnd: function(e) {
			console.log(e.propertyName);
			if (e.propertyName === 'transform') {
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', dm.menuEnd);
			}
		},
		btnEnd: function(e) {
			if (e.propertyName === 'opacity') {
				this.classList.remove('is-anim');
			}
		}
	};
	
	/**
	 * スムーススクロール
	 * as.toScroll('top');
	 -------------------------------------------------- */
	function anchorScroll() {
		if (document.querySelector('.js-anc') !== null || location.hash) as.constructor();
	}
	const as = {
		constructor: function() {
			//console.log('-----> anchorScroll');
			
			// URL に hash があったらスクロール
			if (location.hash) this.autoScroll(location.hash);
			
			this.SPF = 1000 / 60;
			this.duration = 1000;
			this.onResize();
			this.cancelScroll(this);
			const anchor = document.querySelectorAll('.js-anc[href^="#"]');
			for (let i = 0, len = anchor.length; i < len; i++) {
				anchor[i].addEventListener('click', this.onClick);
			}
		},
		autoScroll: function(hash) {
			setTimeout(function() {
				as.toScroll(hash.slice(1));
				history.replaceState('', document.title, window.location.pathname);
			}, 60);
		},
		onClick: function(e) {
			e.preventDefault();
			const targetId = this.closest('[href]').getAttribute('href');
			as.toScroll(targetId.slice(1));
		},
		onResize: function() {
			as.d = {
				scBtm: wm.body.offsetHeight - window.innerHeight,
				scPad: document.getElementsByClassName('l-header')[0].clientHeight,
				scMax: wm.body.clientHeight - window.innerHeight
			}
			// body の高さが取得できなかった場合 0.06 秒後に改めて実行
			if (as.d.scMax < 0) setTimeout(as.onResize, 60);
		},
		toScroll: function(targetId) {
			if (targetId !== 'top' && document.getElementById(targetId) === null) return;
			
			// ドロワーメニューが開いていたら、開いた時の位置からスタート (メニューは閉じる)
			this.startPos = (dm.isOpened) ? dm.yOffset : window.pageYOffset;
			if (dm.isOpened) dm.closeMenu();
			
			this.currentPos = this.startPos;
			this.elapsedTime = 0;
			this.goalPos = (targetId !== 'top') ? (document.getElementById(targetId).getBoundingClientRect().top + window.pageYOffset - this.d.scPad) : 0;
			
			if (this.goalPos >= this.d.scMax) this.goalPos = this.d.scMax;
			
			this.valueInChange = this.goalPos - this.startPos;
			this.doScroll();
			this.hash = '#' + targetId;
		},
		doScroll: function() {
			// #top 以外は hash 付与
			if (as.hash !== '#top') {
				if (location.hash !== as.hash && as.hash !== null) location.hash = as.hash;
			} else {
				if (as.hash !== null) location.hash = '';
			}
			
			const elapsedTimeRate = as.elapsedTime / as.duration;
			const valueChangeRate = as.easing(elapsedTimeRate);
			const changeYOffset = as.valueInChange * valueChangeRate;
			
			as.currentPos = as.startPos + changeYOffset;
			
			if (as.elapsedTime >= as.duration) {
				as.currentPos = as.goalPos;
				clearTimeout(as.timer);
				return;
			
			} else {
				as.elapsedTime += as.SPF;
				as.timer = setTimeout(as.doScroll, as.SPF);
			}
			window.scrollTo(0, as.currentPos);
		},
		/* スワイプするかマウスホイールを操作したらスクロールを止める */
		cancelScroll: function(t) {
			//console.log(t);
			let count = 0;
			if (isTouch) {
				window.addEventListener('touchmove', function() {
					clearTimeout(t.timer);
				});
			} else {
				this.wheel = function() {
					clearTimeout(t.timer);
				}
				if (window.addEventListener) { window.addEventListener('DOMMouseScroll', this.wheel, false); }
				window.onmousewheel = document.onmousewheel = this.wheel;
			}
		},
		/* easeOutExpo ( https://easings.net/ ) */
		easing: function(x) {
			return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
		}
	};
	
	/**
	 * .pagetop を固定
	 -------------------------------------------------- */
	function pagetopFix() {
		if (document.querySelector('.pagetop') !== null) ptf.constructor();
	}
	const ptf = {
		constructor: function() {
			this.activeLimit = 200;
			this.footer = document.getElementsByClassName('l-footer')[0];
			this.pagetop = document.getElementsByClassName('pagetop')[0];
			this.refresh();
			//console.log(this.footerPos);
		},
		refresh: function() {
			this.check = this.footer.getBoundingClientRect().top + wm.yOffset;
			this.footerPos = this.footer.getBoundingClientRect().top + wm.yOffset + 80;
			
			this.isActive = wm.yOffset > this.activeLimit;
			if (this.isActive) {
				this.pagetop.classList.add('is-active');
			}
			this.isFixed = this.footerPos >= wm.yOffset + wm.winH;
			if (this.isFixed) {
				this.pagetop.classList.add('is-fixed');
			}
		},
		onScroll: function() {
			if (this.footerPos >= wm.yOffset + wm.winH) {
				this.doFix();
			} else {
				this.noFix();
			}
			if (wm.yOffset > this.activeLimit) {
				this.doView();
			} else {
				this.noView();
			}
			// フッターの位置が違ったら再取得
			if (this.check !== this.footer.getBoundingClientRect().top + wm.yOffset) this.refresh();
		},
		doFix: function() {
			if (!this.isFixed) {
				this.isFixed = true;
				this.pagetop.classList.add('is-fixed');
			}
		},
		noFix: function() {
			if (this.isFixed) {
				this.isFixed = false;
				this.pagetop.classList.remove('is-fixed');
			}
		},
		doView: function() {
			if (!this.isActive) {
				this.isActive = true;
				this.pagetop.classList.add('is-active', 'is-anim');
			}
		},
		noView: function() {
			if (this.isActive) {
				this.isActive = false;
				this.pagetop.classList.replace('is-active', 'is-anim');
			}
		}
	};
	
	/**
	 * fetch が使えたら fetch、使えなかったら xhr で Ajax する
	 * doAjax(request, function() {}, 'text');
	 * fetchAjax(request, function() {}, 'json');
	 * xhrAjax(request, function() {}, 'blob');
	 * -------------------------------------------------- */
	function doAjax(req, fn, format) {
		if (self.fetch) {
			fetchAjax(req, fn, format)
		} else {
			xhrAjax(req, fn, format)
		}
	}
	function fetchAjax(req, fn, format) {
		//console.log('-----> fetchAjax');
		fetch(req)
		.then(function(response) {
			return new Promise(function(resolve, reject) {
				return response[format]()
				.then(function(data) {
					return resolve(data);
				}, function(error) {
					return reject(error);
				});
			});
		})
		.then(function(data) {
			//console.log('success ----->', JSON.stringify(data))
			fn(data);
		}, function(error) {
			console.log('error -----> '.concat(error));
		});
	};
	function xhrAjax(req, fn, format) {
		//console.log('-----> xhrAjax');
		const xhr = new XMLHttpRequest();
		xhr.responseType = format;
		xhr.addEventListener('progress', function(e) {
			const rate = e.loaded / (e.total == 0 ? e.loaded : e.total);
			console.log(e, rate);
		});
		xhr.addEventListener('load', function(e) {
			if (xhr.readyState === 4) {
				if (xhr.status == 200 || xhr.status == 304) {
					let data = e.target.response;
					if (format === 'json') data = JSON.parse(data);
					fn(data);
				}
			}
		});
		xhr.open('GET', req);
		xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
		xhr.send();
	};
	
	/**
	 * in-view
	 * <ul class="js-inview" data-last="li:last-child"></ul>
	 * <ul class="js-inview" data-last><li></li><li></li><li class="iv-last"></li></ul>
	 * <ul class="js-inview" data-anim="animationName"></ul>
	 * <img data-src="path.jpg" alt="" width="w" height="h">
	 * -------------------------------------------------- */
	function setInview() {
		if (document.querySelector('.js-inview') !== null) iv.constructor();
	}
	const iv = {
		constructor: function() {
			inView('.js-inview').on('enter', this.doInview);
			inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });
		},
		doInview: function(el) {
			if (!el.isInview) {
				el.isInview = 1;
				if (el.dataset['anim'] !== undefined) {
					el.addEventListener('animationend', iv.animationEnd);
				} else if (el.dataset['last'] !== undefined) {
					el.addEventListener('transitionend', iv.lastElmEnd);
				} else {
					el.addEventListener('transitionend', iv.transitionendEnd);
				}
				el.classList.add('is-anim');
				el.classList.add('is-inview');
			}
		},
		animationEnd: function(e) {
			if (e.animationName === this.dataset['anim']) {
				this.classList.remove('is-anim', 'js-inview');
				this.removeAttribute('data-anim');
				this.removeEventListener('animationend', iv.animationEnd);
			}
		},
		lastElmEnd: function(e) {
			if (this.dataset['last'] !== '') {
				if (e.target === this.querySelector(this.dataset['last'])) {
					this.classList.remove('is-anim', 'js-inview');
					this.removeAttribute('data-last');
					this.removeEventListener('transitionend', iv.lastElmEnd);
				}
			} else {
				if (e.target.className.indexOf('iv-last') >= 0) {
					e.target.classList.remove('iv-last');
					this.classList.remove('is-anim', 'js-inview');
					this.removeAttribute('data-last');
					this.removeEventListener('transitionend', iv.lastElmEnd);
				}
			}
		},
		transitionendEnd: function(e) {
			if (e.target === this) {
				this.classList.remove('is-anim', 'js-inview');
				this.removeEventListener('transitionend', iv.transitionendEnd);
			}
		}
	};
	
	/**
	 * lazy image
	 * -------------------------------------------------- */
	function setLazy() {
		if (document.querySelector('[data-src]') !== null) lz.constructor();
	}
	const lz = {
		constructor: function() {
			const imgs = document.querySelectorAll('img[data-src]');
			
			if (self.IntersectionObserver !== undefined) {
				let cls, w, h;
				for (let i = 0, len = imgs.length; i < len; i++) {
					cls = imgs[i].getAttribute('class') ? ' ' + imgs[i].getAttribute('class') : '';
					w = imgs[i].getAttribute('width');
					h = imgs[i].getAttribute('height');
					imgs[i].src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 ' + w + ' ' + h + '%22%3E%3C/svg%3E';
				}
				this.lazy(imgs);
				
			} else {
				for (let i = imgs.length; i--;) {
					imgs[i].src = imgs[i].dataset['src'];
					imgs[i].removeAttribute('data-src');
				}
			}
		},
		lazy: function(imgs) {
			this.intersectionObserver = new IntersectionObserver(function(entries) {
				for (let i = 0; i < entries.length; i++) {
					if (entries[i].intersectionRatio <= 0) continue;
					lz.doLazy(entries[i].target);
				}
			}, {
				rootMargin: '-80px 0px -80px 0px'
			});
			for (let i = 0; i < imgs.length; i++) {
				this.intersectionObserver.observe(imgs[i]);
			}
		},
		doLazy: function(el) {
			imagesLoaded(el, lz.loaded);
			el.src = el.dataset['src'];
			lz.intersectionObserver.unobserve(el);
		},
		loaded: function() {
			this.elements[0].classList.add('is-anim', 'is-loaded');
			this.elements[0].addEventListener('transitionend', lz.loadedEnd);
		},
		loadedEnd: function() {
			this.classList.remove('is-anim');
			this.removeAttribute('data-src');
			this.removeEventListener('transitionend', lz.loadedEnd);
		}
	};
	
	/**
	 * 脚注 [data-ref] と [data-note] の行き来
	 * refNote();
	 -------------------------------------------------- */
	function refNote() {
		if (document.querySelector('[data-ref]') !== null) rn.constructor();
	}
	const rn = {
		refArray: {},
		constructor: function() {
			const ref = document.querySelectorAll('[data-ref]');
			const note = document.querySelectorAll('[data-note]');
			
			for (let i = 0, len = ref.length; i< len; i++) {
				this.refDatalize(ref[i], ref[i].dataset['ref']);
				ref[i].firstChild.addEventListener('click', this.onClick)
			}
			//console.log(this.refArray);
			for (let i = 0, len = note.length; i < len; i++) {
				this.createNoteLink(note[i], note[i].dataset['note']);
			}
		},
		/* 脚注番号に id 付与して脚注へのリンク設置 */
		refDatalize: function(elm, id) {
			// 同じ脚注番号には _n 連番を付与
			if (this.refArray['cite_ref-' + id] === undefined) {
				this.refArray['cite_ref-' + id] = [];
			}
			this.refArray['cite_ref-' + id].push('note');
			elm.id = 'cite_ref-' + elm.dataset['ref'] + '_' + this.refArray['cite_ref-' + id].length;
			
			elm.removeAttribute('data-ref');
			elm.innerHTML = '<a href="#cite_note-' + id + '" class="js-anc">' + elm.innerHTML + '</a>';
		},
		/* 脚注にも id 付与して、いったん一番上の脚注番号へのリンク設置 */
		createNoteLink: function(elm, id) {
			elm.innerHTML = '<span id="cite_note-' + id + '">' + elm.innerHTML + '</span>';
			elm.insertAdjacentHTML('afterbegin', '<sup><a href="#cite_ref-' + id + '_1" class="js-anc">^</a></sup>');
		},
		/* 脚注番号をクリックしたら、注釈の href を書き換える */
		onClick: function(e) {
			const noteElm = document.getElementById(this.getAttribute('href').slice(1));
			const refAnchor = noteElm.parentNode.getElementsByClassName('js-anc')[0];
			refAnchor.href = '#' + this.parentNode.id;
		}
	};
	
	/**
	 * ソース最適化
	 -------------------------------------------------- */
	function improvementSource() {
		isrc.constructor();
	}
	const isrc = {
		constructor: function() {
			if (document.querySelector('a[target]:not([rel])') !== null) this.forBestPractices();
		},
		forBestPractices: function() {
			const blankLinks = document.querySelectorAll('a[target]:not([rel])');
			for (let i = blankLinks.length; i--;) {
				blankLinks[i].setAttribute('rel', 'noopener');
				
			}
		}
	}
		
	/**
	 * common
	 * -------------------------------------------------- */
	const resized = function(fn) {
		if (resized.timer !== false) clearTimeout(resized.timer);
		resized.timer = setTimeout(fn, 200);
	};
	const throttle = (function(fn) {
		const interval = 200;
		let lastTime = new Date().getTime() - interval;
		return function(fn) {
			if ((lastTime + interval) <= new Date().getTime()) {
				lastTime = new Date().getTime();
				fn();
			}
		}
	})();
	let isIE, isTouch, isWindows;
	function addFnc(fns) {
		for (let i = 0, len = fns.length; i < len; i++) { fns[i](); }
	}
	(function common() {
		const doc = document.documentElement, ua = navigator.userAgent.toLowerCase();
		isIE = ( ua.indexOf('msie') != -1 || ua.indexOf('trident') != -1 );
		isWindows = ua.indexOf('windows nt') !== -1;
		isTouch = !!( 'ontouchstart' in window || (navigator.pointerEnabled && navigator.maxTouchPoints > 0) );
		if (isIE) doc.classList.add('isIE');
		if (isWindows) doc.classList.add('isWindows');
		if (isTouch) doc.classList.add('isTouch');
		if (window.innerWidth !== doc.clientWidth) {
			doc.classList.add('hasScrollbar');
			doc.style.setProperty('--scroll-bar-width', window.innerWidth - doc.clientWidth + 'px');
		}
	})();
	// Element.closest() Polyfill
	Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(e){var t=this;do{if(Element.prototype.matches.call(t,e))return t;t=t.parentElement||t.parentNode}while(null!==t&&1===t.nodeType);return null});
})((this || 0).self || global);